import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal, NgbDatepickerModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import dayjs, { Dayjs } from 'dayjs';
import { IAppState } from '../../../app/app.reducer';
import { Store } from '@ngrx/store';
import { bootstrapCalendarFill } from '@ng-icons/bootstrap-icons';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { setOrderToComplete } from '../../orders/order.actions';
import { MogoDropzoneComponent } from '../../mogo-dropzone/mogo-dropzone.component';

@Component({
  selector: 'app-complete-order-modal',
  standalone: true,
  imports: [ReactiveFormsModule, NgbTimepickerModule, NgbDatepickerModule, NgIconComponent, MogoDropzoneComponent],
  templateUrl: './complete-order-modal.component.html',
  styleUrls: ['./complete-order-modal.component.scss'],
  viewProviders: [provideIcons(
    {
      bootstrapCalendarFill
    }
  ),
  ]
})
export class CompleteOrderModalComponent implements OnInit {
  @Input()
  orderId: number | null = null;

  @Input()
  defaultStartDateTime: Dayjs | null = null;

  completeOrderForm: FormGroup | undefined = undefined;

  constructor(protected activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private store$: Store<IAppState>) { }

  ngOnInit() {
    this.initializeForm();
  }

  initializeForm() {
    this.completeOrderForm = this.formBuilder.group({
      orderId: this.formBuilder.control(this.orderId, [Validators.required]),
      receivedBy: this.formBuilder.control('', [Validators.required]),
      completedDate: this.formBuilder.group({
        date: this.formBuilder.control({
          year: this.defaultStartDateTime?.year(),
          month: this.defaultStartDateTime?.add(1, 'month').month(),
          day: this.defaultStartDateTime?.date()
        }, [Validators.required]),
        time: this.formBuilder.control({
          hour: this.defaultStartDateTime?.hour(),
          minute: this.defaultStartDateTime?.minute()
        }, [Validators.required])
      }),
      podAttachments: this.formBuilder.control<File[]>([]),
    });
  }

  clear() {
    this.completeOrderForm?.reset();
    this.completeOrderForm?.get('podAttachments')?.setValue([]);
  }

  completeOrder() {
    if (this.completeOrderForm?.valid && this.orderId) {
      const date = dayjs(new Date(
        this.completeOrderForm?.value.completedDate.date.year,
        this.completeOrderForm?.value.completedDate.date.month - 1,
        this.completeOrderForm?.value.completedDate.date.day,
        this.completeOrderForm?.value.completedDate.time.hour,
        this.completeOrderForm?.value.completedDate.time.minute
      )).toISOString();

      const request = {
        orderId: this.orderId,
        receivedBy: this.completeOrderForm?.value.receivedBy,
        completedDate: date,
        podAttachments: this.completeOrderForm?.value.podAttachments
      };

      this.store$.dispatch(setOrderToComplete(request));
      this.activeModal.close(this.completeOrderForm?.value);
    } else {
      this.completeOrderForm?.markAllAsTouched();
    }
  }
}
